module.exports = __webpack_public_path__ + "img/index_part2img2.a218e329.jpg";